import createHTMLMediaHook from "./createHTMLMediaHook.mjs";
export var useVideo = createHTMLMediaHook('video');